// ** MUI Imports
import Box from '@mui/material/Box'

// ** Custom Components Imports
import CustomAvatar from 'src/@core/components/mui/avatar'
import { useMemo } from 'react'
import { isEmpty } from 'lodash'
import { Tooltip } from '@mui/material'

const defaultAvatar = 'U'

function getInitials(fullName: string = defaultAvatar) {
  const nameParts = fullName.trim().split(' ')
  const firstInitial = nameParts[0] ? nameParts[0][0].toUpperCase() : ''
  const lastInitial = nameParts.length > 1 ? nameParts[nameParts.length - 1][0].toUpperCase() : ''
  const avatarLetters = firstInitial + lastInitial

  return isEmpty(avatarLetters.trim()) ? defaultAvatar : avatarLetters
}

const AvatarsLetter = ({ name, role }: { name: string; role: string }) => {
  const initials = useMemo(() => getInitials(name), [name])

  return (
    <Box sx={{ display: 'flex' }}>
      <Tooltip title={role} placement='top'>
        <CustomAvatar sx={{ width: 28, height: 28, fontSize: 12, color: '#171717' }}>{initials}</CustomAvatar>
      </Tooltip>
    </Box>
  )
}

export default AvatarsLetter
